import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import guillaumeBackground from "../../images/guillaume_lafond_images/GSTL1109.jpg"; // Make sure this path is correct

const Container = styled.div`
  ${tw`relative bg-center bg-no-repeat min-h-screen w-screen`}
  background-image: url(${guillaumeBackground});
  background-size: cover; /* Ensure full coverage */
  background-position: left center; /* Move image to the left */
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);

  /* Adjusting height */
  height: 100vh; /* Sets the height to be at least the full viewport height */
  min-height: 500px; /* Sets a minimum height for the image */

  /* Media Query for screens smaller than 1200px */
  @media (max-width: 1200px) {
    background-size: cover;
    background-position: 10% center;
  }

  /* Media Query for screens smaller than 768px */
  @media (max-width: 768px) {
    background-size: cover;
    background-position: 50% center;
  }

  /* Media Query for screens smaller than 500px */
  @media (max-width: 500px) {
    background-size: cover;
    background-position: 40% center;
  }
`;

const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-black opacity-25`;

const HeroContainer = tw.div`z-20 relative mx-auto h-full flex flex-col`;

const AlbumAndButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-top: auto;
  margin-bottom: auto;

  @media (max-width: 500px) {
    margin-right: 0; /* Remove right margin on smaller screens */
    margin-bottom: 30px; /* Reduced bottom margin on smaller screens */
  }
`;

const Content = styled.div`
  ${tw`flex justify-between items-center h-full`}
  padding-left: 2%;
  padding-right: 2%;
  gap: 30px; /* Reduced space between album containers */

  @media (max-width: 500px) {
    ${tw`items-center`}
    flex-direction: column; /* Stack items vertically on smaller screens */
    padding-right: 0; /* Remove right padding on smaller screens */
    padding-top: 50px; /* Adjusted to move content lower on smaller screens */
  }

  @media (max-width: 1700px) {
    padding-top: 50px; /* Adjusted to move content lower on smaller screens */
  }
`;

const Column = styled.div`
  display: flex;
  align-items: center;
  gap: 30px; /* Reduced gap between album containers */

  @media (max-width: 2000px) {
    flex-direction: column;
  }

  @media (max-width: 500px) {
    flex-direction: row;
  }
`;

export default () => {
  return (
    <Container>
      <OpacityOverlay />
        <HeroContainer>
          <Content>
            <Column>
              <AlbumAndButtonContainer>
              </AlbumAndButtonContainer>
              <AlbumAndButtonContainer>
              </AlbumAndButtonContainer>
            </Column>
          </Content>
        </HeroContainer>
    </Container>
  );
};
